import React, { Component } from 'react';
import moment from 'moment';
import ProductsHelper from '../components/ProductsHelper'
import './css/customerConfirm.css'
import CustomerInfo from '../components/CustomerInfo';
// import ContactPersons from '../components/ContactPersons'


class CustomerConfirm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFirstSave: props.current.isFirstSave,
            mode: "",
            signature: props.changes.state.signature
        };


        const changes = props.changes.state;

        this.allProducts = this.props.selectableProducts;

        const selectedProducts = ProductsHelper.Get(props.current.orders, changes);

        this.products = [];

        // add products for all the KeKs  (monthly costs)
        if (changes.equipmentAdded) {
            changes.equipmentAdded.map((item, idx) => {
                // lookup the subscriptions
                var subs = item.subscriptionCodes && item.subscriptionCodes.split(",");
                if (item.status === "A" || !subs) {
                    // skip this product, there are no monthly costs
                    return true;
                }

                subs.map((sub, idx) => {
                    this.products.push(this.getProductByCode(sub))
                    return true;
                });
                return true;
            });
        }

        // add products from the order
        if (selectedProducts) {
            selectedProducts.map((item, index) =>

                this.products.push({
                    id: item.item.code,
                    name: item.item.name,
                    quantity: item.quantity,
                    pricePerMonth: 0,
                    price: item.unitPrice
                })
            );
        }
    }

    getProductByCode(sub) {
        // lookup the product
        var art = this.allProducts.find(p => p.item.code === sub);

        if (!art) {
            return {
                id: sub,
                name: sub,
                quantity: "maandelijks",
                pricePerMonth: 0,
                price: 0
            }
        }
        return {
            id: sub,
            name: art.item.name,
            quantity: "maandelijks",
            pricePerMonth: art.unitPrice,
            price: 0
        }
    }

    componentDidMount() {
        const script = document.createElement("script");
        script.src = "/signature.js";
        script.async = true;

        document.body.appendChild(script);

        window.addEventListener('resize', this.Resize.bind(this));

    }

    scriptLoaded() {
        var wrapper = document.getElementById("signature-pad");

        if (wrapper !== null) {
            const canvas = wrapper.querySelector("canvas");
            //if (!this.signaturePad) {
            this.signaturePad = new window.SignaturePad(canvas);

            this.resizeCanvas();
        }
    }

    Resize() {
        // do resize
        this.resizeCanvas();
    }

    resizeCanvas() {
        //if (!$(canvas).is(":visible")) return;
        // When zoomed out to less than 100%, for some very strange reason,
        // some browsers report devicePixelRatio as less than 1
        // and only part of the canvas is cleared then.

        var wrapper = document.getElementById("signature-pad");
        if (!wrapper) return;
        var canvas = wrapper.querySelector("canvas");
        if (!canvas) return;

        var ratio = Math.max(window.devicePixelRatio || 1, 1);
        ratio=1;

        canvas.width = 520 * ratio;
        canvas.height = 200 * ratio;
        // canvas.width = 780 * ratio;
        // canvas.height = 300 * ratio;

        var context = canvas.getContext("2d");
        var zoom=1;
        context.scale(ratio *zoom, ratio*zoom);
        // set background color
        context.fillStyle = '#fff'; // <- background color
        // draw background / rect on entire canvas  (background color white)
        context.fillRect(0, 0, canvas.width, canvas.height);

        if (this.props.changes.state.signature) {
            this.signaturePad.fromDataURL(this.props.changes.state.signature);
        }
    }


    doReset() {
        if (this.signaturePad) this.signaturePad.clear();
        this.setState({ signature: "" });
        this.props.changes.state.signature = null;

        this.startSign();
    }

    writeTime(n) {
        return moment(n).format('HH:mm')
    }

    startSign() {
        this.setState({ mode: "sign", signatureStarted: false, signatureMissing: false })
        setTimeout(() => this.scriptLoaded(), 200);
    }

    signCancel() {
        this.signaturePad.clear();
        this.props.changes.state.signature = null;
        this.setState({ mode: "" });
    }

    capture() {
        if (!this.signaturePad) return;
        this.setState({ signatureStarted: true });
        var x = this.signaturePad.toDataURL();
        //console.log("capture", x);
        this.props.changes.state.signature = x;
        this.props.changes.state.timeEnd = new Date();
        return x;
    }
    signComplete() {
        if (!this.state.signatureStarted) {
            this.setState({ signatureMissing: true });
            return;      // not signed anything

        }

        const x = this.capture();
        this.setState({ mode: "", signature: x });
    }


    render() {
        const bon = this.props.current;


        const products = this.products.map((item, index) => <tr key={index}>
            <td>{item.name}</td>
            <td className="col-md-1">{item.quantity}</td>
            {/* <td className="col-md-1 text-end">{item.price > 0 ? item.price.toFixed(2) :
                item.pricePerMonth > 0 ? item.pricePerMonth.toFixed(2) :
                    0.00}</td> */}
        </tr>);

        const bp = bon.serviceCall.businessPartner;

        return <div>


            {this.state.mode === "" &&
                <React.Fragment>
                    <div className="row">
                        <div className="col mb-4">
                            <h4>Bevestiging klant</h4>
                            <CustomerInfo bp={bp} changes={this.props.changes}></CustomerInfo>



                            <h4>Overzicht</h4>

                            {
                                this.products && this.products.length > 0 &&

                                <table className="table table-striped table-sm" >
                                    <thead>
                                        <tr>
                                            <th>Artikel</th>
                                            <th className="col-md-1">Aantal</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {products}
                                    </tbody>
                                </table>
                            }

                            {/* <div>Totaal maandelijkse kosten: {this.products.reduce((a, v) => a = a + v.pricePerMonth, 0).toFixed(2)} </div>
<div>Totaal eenmalige kosten: {this.products.reduce((a, v) => a = a + v.price, 0).toFixed(2)}</div> */}

                            {bp.iban !== "" &&
                                <div className="mt-4">IBAN rekening {bp.iban}</div>
                            }

                            {
                                this.props.changes.state.resolution &&
                                <fieldset className="mt-4"><legend>Werkzaamheden</legend>
                                    {this.props.changes.state.resolution}

                                </fieldset>

                            }
                        </div>
                        <div className="col">
                            {this.state.isFirstSave &&
                                <table>
                                    <tbody>
                                        <tr>
                                            <td>Monteur aankomst: </td>
                                            <td><i className="fa-solid fa-clock"></i> {this.writeTime(this.props.changes.state.timeStart)}</td>
                                        </tr>
                                        <tr>
                                            <td>Eind werkzaamheden:</td>
                                            <td><i className="fa-solid fa-clock"></i>&#160;
                                                {
                                                    this.props.changes.state.timeEnd &&
                                                    <span>
                                                        {this.writeTime(this.props.changes.state.timeEnd)}
                                                    </span>
                                                }
                                                {
                                                    !this.props.changes.state.timeEnd &&
                                                    <span>
                                                        {this.writeTime(new Date())}
                                                    </span>
                                                }</td>
                                        </tr>
                                    </tbody>
                                </table>
                            }

                            {this.state.isFirstSave &&
                                <>
                                    <div className="mt-4">
                                        <p>Door ondertekening van dit formulier geeft u aan voldoende te zijn geïnformeerd, bevestigd in een brief, omtrent de mogelijke gevolgen van uw aansluiting bij het door u gekozen type alarmeringstoestel. Daarbij geeft u toestemming aan CSI Service om doorlopend incasso-opdrachten te sturen naar uw bank om een bedrag van uw rekening af te schrijven wegens verschuldigde kosten voor professioneel alarm en uw bank om doorlopend een bedrag van uw rekening af te schrijven overeenkomstig de opdracht van CSI Service.</p>
                                        <p>Als u het niet eens bent met deze afschrijving kunt u deze laten terugboeken. Neem hiervoor binnen acht weken na afschrijving contact op met uw bank. Vraag uw bank naar de voorwaarden.</p>
                                    </div>

                                    {!this.state.signature &&
                                        <button className="btn btn-success" onClick={this.startSign.bind(this)}>tekenen</button>

                                    }
                                    {this.state.signature &&
                                        <div>



                                            <div>Handtekening:</div>
                                            <img alt="signature" src={this.state.signature}></img><br />
                                            <button className="btn btn-secondary " onClick={this.doReset.bind(this)}>Opnieuw tekenen</button>

                                        </div>

                                    }
                                </>
                            }

                        </div>
                    </div>


                </React.Fragment>
            }
            {this.state.mode === "sign" &&
                <div>
                    <div className="signature-back"></div>

                    <div className="signature-front">
                        <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.signCancel.bind(this)}>
                            <i className="fa-sharp fa-solid fa-xmark"></i>
                        </button>

                        <div className="col mt-4">
                            Handtekening:
                        </div>
                        <div className="m-signature-pad" id="signature-pad">
                            <canvas onMouseUp={this.capture.bind(this)} onTouchEnd={this.capture.bind(this)}></canvas>
                        </div>
                        {this.state.signatureMissing && <div className="text-danger">
                            Er moet eerst een handtekening worden gezet
                        </div>}
                        <div className="sticky-bottom row">
                            <div className="col">
                                <button className="btn btn-secondary mt-4" onClick={this.doReset.bind(this)}>leegmaken</button>
                            </div>

                            <div className="col-auto ms-auto">
                                <button className="btn btn-success ms-2 mt-4" onClick={this.signComplete.bind(this)}>bevestigen</button>

                            </div>
                        </div>


                    </div>
                </div>
            }

        </div>

    }
}


export default CustomerConfirm;